/**
 * Handles how the page should respond to changing display widths
 *
 * Injections:
 *   $window : to listen for window resize
 */

export function ResponsiveController($scope, $window, $rootScope, cartService, $state, $timeout) {
    'ngInject';
    $scope.curWidth = $window.innerWidth;
    // Using 700px as the limit for a mobile width, consistent with the css media selectors used
    $scope.isMobile = $scope.curWidth <= 700;
    // Represents whether the left panel should show or hide
    $scope.showRight = !$scope.isMobile;

    const TABS = {
        menu: 'menu',
        spotlight: 'spotlight'
    };
    $scope.tabs = TABS;
    $scope.activeTab = TABS.menu;

    function _activate() {
        // For oo-enlightenment, we need the feature flags loaded before calling getCart().
        // In config.js we've configured the $stateProvider to require the feature flags to load,
        // in order to not have to update all the feature flag checking code to be async,
        // but here the ResponsiveController loads before the initial state is set.
        const stateSetCallback = () => {
            cartService.getCart()
                .then(() => $scope.cartData = cartService.data);
        };

        if ($state.current && $state.current.name) {
            stateSetCallback();
        } else {
            const deregisterStateChangeSuccess = $rootScope.$on('$stateChangeSuccess', () => {
                deregisterStateChangeSuccess();
                stateSetCallback();
            });
        }

        // Invokes view to be updated when window is resized
        angular.element($window).on('resize', $scope.updateView);
    }

    /**
         * updateView(): updates the values used for mobile responsiveness
         *  -> invokes a digest cycle to proliferate changes to html
         */
    $scope.updateView = function() {
        $scope.curWidth = $window.innerWidth;
        $scope.isMobile = $scope.curWidth <= 700;
        if (!$scope.isMobile) {
            $scope.showRight = true;
        }
        $timeout(angular.noop);
    };

    $scope.setActiveTab = function(tab) {
        if(Object.values(TABS).indexOf(tab) !== -1) {
            $scope.activeTab = tab;
        }
    };

    $scope.openMenuTab = function() {
        $scope.showRight = false;
        $scope.activeTab = TABS.menu;
    };

    $scope.openSpotlightTab = function() {
        $scope.activeTab = TABS.spotlight;
    };

    $scope.setPlayStringsOnRootScope = function() {
        $rootScope.strings = $scope.strings;
    };


    _activate();
}
